export enum ErrorCode {
  TIMEOUT = "TIMEOUT",
  PERMISSION_DENIED = "PERMISSION_DENIED",
  ALREADY_MEMBER = "ALREADY_MEMBER",
  TEAM_NOT_FOUND = "TEAM_NOT_FOUND",
  NETWORK_ERROR = "NETWORK_ERROR",
  UNKNOWN = "UNKNOWN"
}

export interface ApiError {
  code: ErrorCode;
  message: string;
  details?: string;
}

export class TeamJoinError extends Error {
  code: ErrorCode;
  details?: string;

  constructor(code: ErrorCode, message: string, details?: string) {
    super(message);
    this.name = "TeamJoinError";
    this.code = code;
    this.details = details;
  }
}
